import React, { useEffect, useState } from 'react';
import LearnosityProvider from 'legacy/src/utility/LearnosityProvider';
import cn from 'classnames';

import './LearnosityQuestionEditor.scss';

const LearnosityQuestionEditor = ({
  initOptions,
  widgetJson = {},
  widgetTemplate = '',
  isLoading = false,
  hasNoToolbar = false,
  shouldSetWidgets = false,
  onReady = () => {},
  onStimilusChange = () => {},
  onOptionsChange = () => {},
  onValidationChange = () => {},
  onceWidgetReady = () => {},
}) => {
  const [learnosityAppInstance, setLearnosityAppInstance] = useState(null);
  useEffect(() => {
    if (learnosityAppInstance) {
      if (shouldSetWidgets) {
        setTimeout(() => {
          learnosityAppInstance.setWidget(widgetJson, widgetTemplate);
        }, 0);
      }

      const changeEvents = () => {
        const data = learnosityAppInstance.getWidget();
        if (data) {
          const { stimulus, options, validation } = data;
          onStimilusChange(stimulus);
          onOptionsChange(options);
          onValidationChange(validation);
        }
      };

      // on modifying any widget(question) attribute send events for validation
      learnosityAppInstance.on('widgetedit:preview:changed', changeEvents);
      learnosityAppInstance.on('widgetedit:widget:ready', changeEvents);
      learnosityAppInstance.on('render:item', changeEvents);
      learnosityAppInstance.once('widgetedit:widget:ready', onceWidgetReady);

      return () => {
        learnosityAppInstance.off('widgetedit:preview:changed', changeEvents);
        learnosityAppInstance.off('widgetedit:widget:ready', changeEvents);
      };
    }
  }, [learnosityAppInstance]);

  return (
    <div className="LearnosityQuestionEditor display-correct-answers">
      {!isLoading && initOptions && (
        <LearnosityProvider
          className={cn('LearnosityQuestionEditor__lrn', {
            '--no-toolbar': hasNoToolbar,
          })}
          containerElement="learnosity-question-editor"
          apiType="authoring"
          initOptions={initOptions}
          readyListener={(app) => {
            onReady(app);
            setLearnosityAppInstance(app);
          }}
          shouldDestroy={false}
        />
      )}
    </div>
  );
};

export default LearnosityQuestionEditor;
